import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon, MapPinIcon } from 'lucide-react';
import { PageHero } from '../components/layout/PageHero';
import { SectionHeading } from '../components/ui/SectionHeading';
import { Reveal } from '../components/ui/Reveal';
import { CtaBand } from '../components/ui/CtaBand';
import { regions } from '../data/regions';
export function Nigeria() {
  return <>
      <PageHero eyebrow="Regional agenda" title="What this plan means where you live." intro="Six geopolitical zones, 36 states and the FCT. One national standard, applied to very different realities." crumbs={[{
      label: 'Home',
      to: '/'
    }, {
      label: 'Nigeria'
    }]} data-id="element-1191" data-mp="3pjje1q4g4pzr" />

      <section className="bg-sand-50 py-16 lg:py-24" aria-labelledby="zones-heading" data-id="element-1192" data-mp="7dxxi1j8xt6u">
        <div className="mx-auto max-w-content px-4 sm:px-6 lg:px-10" data-id="element-1193" data-mp="1er84cgk7u6k2">
          <SectionHeading eyebrow="Choose your zone" title="Start with your region" intro="Each zone page sets out priority commitments, the national policies behind them and the campaign activity happening locally." data-id="element-1194" data-mp="1is1px3a6r99s" />

          <div className="mt-8 max-w-sm lg:hidden" data-id="element-1195" data-mp="1y91x985guo0f">
            <label htmlFor="zone-jump" className="mb-2 block text-[14px] font-medium text-ink" data-id="element-1196" data-mp="1t8mkahp3jiiz">
              Jump to a zone
            </label>
            <select id="zone-jump" defaultValue="" onChange={event => {
            if (event.target.value) window.location.assign(event.target.value);
          }} className="w-full rounded-lg border border-sand-300 bg-white px-4 py-3 text-[15px] text-ink" data-id="element-1197" data-mp="1p7auab2b8va9">
              <option value="" data-id="element-1198" data-mp="15jv0adlnu6ha">Select a region</option>
              {regions.map(region => <option key={region.id} value={`/nigeria/${region.id}`} data-id="element-1199" data-mp="11hq9dmmljnyc">
                  {region.name}
                </option>)}
            </select>
          </div>

          <ul className="mt-10 grid gap-5 md:grid-cols-2 lg:grid-cols-3" data-id="element-1200" data-mp="wl99xw9y5n5y">
            {regions.map((region, index) => <li key={region.id} data-id="element-1201" data-mp="qwmmr64vpp25" data-mpi={index}>
                <Reveal delay={Math.min(index, 5) * 0.03} className="h-full" data-id="element-1202" data-mp="qxnub0mortf4">
                  <Link to={`/nigeria/${region.id}`} className="group flex h-full flex-col rounded-card border border-sand-200 bg-white p-6 transition-[border-color,box-shadow] duration-200 ease-emphasis hover:border-green-200 hover:shadow-card" data-id="element-1203" data-mp="cxwohn6bpjc7">
                    <span className="flex items-center gap-2 text-[12px] font-bold uppercase tracking-[0.12em] text-green-700" data-id="element-1204" data-mp="1ajtyew6n0gcj">
                      <MapPinIcon aria-hidden className="h-4 w-4" data-id="element-1205" data-mp="vvpexpzrg0sp" />
                      {region.states.length} states
                    </span>
                    <span className="mt-3 font-display text-[24px] leading-tight text-ink" data-id="element-1206" data-mp="1okwkh8xmtqng">
                      {region.name}
                    </span>
                    <span className="mt-2 font-display text-[16px] leading-snug text-gold-600" data-id="element-1207" data-mp="1tco6d65uf879">
                      {region.headline}
                    </span>
                    <span className="mt-3 text-[14px] leading-relaxed text-slate-600" data-id="element-1208" data-mp="393guerbzxrvw">
                      {region.detail}
                    </span>
                    <span className="mt-auto inline-flex items-center gap-2 pt-6 text-[14px] font-semibold text-green-700" data-id="element-1209" data-mp="3mvwtxi5ov7s2">
                      Explore the {region.name} agenda
                      <ArrowRightIcon aria-hidden className="h-4 w-4 transition-transform duration-200 ease-emphasis group-hover:translate-x-1" data-id="element-1210" data-mp="2v3671y9wavfh" />
                    </span>
                  </Link>
                </Reveal>
              </li>)}
          </ul>
        </div>
      </section>

      <CtaBand title="Bring the agenda to your ward." description="Coordinators are being appointed in all 774 local government areas. There may be a place for you." primary={{
      label: 'Become a coordinator',
      to: '/join'
    }} secondary={{
      label: 'See upcoming events',
      to: '/events'
    }} data-id="element-1211" data-mp="jck9cjosteyn" />
    </>;
}